var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentalFitLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.9863,
    r: 20,
    fill: "url(#paint0_linear_545_29216)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0504 20.5626C34.0504 21.876 32.9847 22.9413 31.6717 22.9413C31.1048 22.9413 30.5844 22.7429 30.1759 22.4126L20.8906 14.2145C21.7946 13.2675 23.07 12.6777 24.4822 12.6777C25.588 12.6777 26.6088 13.0403 27.4336 13.6516L28.0762 14.217C28.0772 14.2194 33.3033 18.8327 33.3033 18.8327C33.7636 19.2652 34.0504 19.8809 34.0504 20.5626Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0156 23.9298C35.0156 25.514 34.3295 26.9384 33.2379 27.9192C32.287 28.7758 31.0277 29.2981 29.6478 29.2981C28.3206 29.2981 27.1058 28.8163 26.1686 28.0179C26.1686 28.0179 13.6177 16.9124 13.4364 16.776C13.434 16.775 13.432 16.7736 13.4296 16.7716C12.7264 16.2463 11.8546 15.9356 10.9106 15.9356C10.2455 15.9356 9.61419 16.0905 9.05469 16.3656C9.31514 15.5007 9.7945 14.732 10.4297 14.1232C11.3616 13.2284 12.6267 12.6777 14.0203 12.6777C15.2566 12.6777 16.3922 13.1102 17.2825 13.8339C17.2825 13.8339 28.3822 23.6581 28.5864 23.8121C29.4846 24.4991 30.6075 24.9062 31.8247 24.9062C33.0209 24.9062 34.1243 24.5138 35.0146 23.8497C35.0156 23.8761 35.0156 23.9034 35.0156 23.9298Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4403 27.6837L22.4399 27.6842C21.5691 28.6742 20.2927 29.2992 18.8688 29.2992C17.784 29.2992 16.7828 28.9357 15.9819 28.3234L15.483 27.8812C15.483 27.8812 8.53098 21.7335 8.41371 21.6421C7.59864 20.9858 6.56369 20.5935 5.43589 20.5935C5.28343 20.5935 5.13341 20.6003 4.98438 20.614C5.18619 20.1424 5.4613 19.709 5.797 19.3303C6.66777 18.3447 7.94118 17.7246 9.35924 17.7246C10.5496 17.7246 11.6373 18.1615 12.471 18.8847L22.4403 27.6837Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_545_29216",
    x1: 1.15272,
    y1: -0.31658,
    x2: 43.4411,
    y2: 37.0971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6162AC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentalFitLogo);
export default __webpack_public_path__ + "static/media/mental-fit-logo.18965f8e40601201c4ed8157345bcde4.svg";
export { ForwardRef as ReactComponent };